export const LINKEDIN_SUBSCRIPTION = {
  BASIC: 1,
  SALES_NAVIGATOR: 2,
  RECRUITER: 3,
}

const LINKEDIN_SUBSCRIPTIONS = tt => [
  {
    name: tt("linkedin-premium-or-basic"),
    value: 1,
  },
  {
    name: tt("sales-navigator"),
    value: LINKEDIN_SUBSCRIPTION.SALES_NAVIGATOR,
  },
  {
    name: tt("linkedin-recruiter"),
    value: LINKEDIN_SUBSCRIPTION.RECRUITER,
  },
]
const linkedinSubscriptionConstants = tt => ({
  LINKEDIN_SUBSCRIPTIONS: LINKEDIN_SUBSCRIPTIONS(tt),
})

export default linkedinSubscriptionConstants
